import React from 'react'
export default function BuleCross (props) {
  return (
    <svg viewBox='0 0 64 64' width={props.width || 20} height={props.height || 20} onClick={props.onClick} style={props.style}>
      <linearGradient id='SVGID_1_' >
        <stop offset='0' style={{ stopColor: '#707FFA' }} />
        <stop offset='1' style={{ stopColor: '#63D5ED' }} />
      </linearGradient>
      <path fill={`url('#SVGID_1_')`} d='M32,52c11,0,20-9,20-20s-9-20-20-20s-20,9-20,20S21,52,32,52z M20.7,34.5l9.9-9.9c0.8-0.8,2-0.8,2.8,0l9.9,9.9  c0.8,0.8,0.8,2,0,2.8s-2,0.8-2.8,0L32,28.8l-8.5,8.5c-0.8,0.8-2,0.8-2.8,0C19.9,36.5,19.9,35.3,20.7,34.5z' />
    </svg>
  )
}
